/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Online_Sections_0_Steps_1Inputs */

const en_gc_search_guides_gridcraft_online_sections_0_steps_1 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Online_Sections_0_Steps_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wait for the spreadsheet grid to appear. The first launch needs to load the browser app; a visible loading message is not yet an editable workbook.`)
};

const zh_gc_search_guides_gridcraft_online_sections_0_steps_1 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Online_Sections_0_Steps_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`等待电子表格网格出现。首次启动需要加载浏览器应用；看到加载提示时，还没有进入可编辑工作簿。`)
};

/**
* | output |
* | --- |
* | "Wait for the spreadsheet grid to appear. The first launch needs to load the browser app; a visible loading message is not yet an editable workbook." |
*
* @param {Gc_Search_Guides_Gridcraft_Online_Sections_0_Steps_1Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_online_sections_0_steps_1 = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Online_Sections_0_Steps_1Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Online_Sections_0_Steps_1Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_online_sections_0_steps_1(inputs)
	return zh_gc_search_guides_gridcraft_online_sections_0_steps_1(inputs)
});
export { gc_search_guides_gridcraft_online_sections_0_steps_1 as "gc.search_guides.gridcraft_online.sections.0.steps.1" }